// Z-index for popup
export const DEFAULT_Z_INDEX = 20;
